import { css } from 'styled-components';
import { theme } from '../../../theme';

export const ButtonStyles = css<{ selected: boolean }>`
  background-color: ${theme.colors.primary.white};
  border-radius: ${theme.borderRadius.default};
  border: 1px solid ${theme.colors.neutrals.solidGrays[5]};
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  max-width: 295px;
  padding: ${theme.spacings[4].rem};
  transition: background-color 200ms ease-in, border-color 200ms ease-in;

  &:hover {
    border-color: ${theme.colors.primary.graysBlue};
  }

  ${({ selected }) =>
    selected &&
    `
    background-color: ${theme.colors.tints.systemBlue[7]};
    border-color: ${theme.colors.primary.graysBlue};
    `}
`;
